<template lang="pug"
src='./walls-tab.pug'>

</template>

<script>
import saveBtn from '@/common/components/saveBtn.vue'
import imgIcon from '@/common/img/baseline-clear-24px.svg'
export default {
	name: 'walls',
	props: ['project', 'control', 'readonly', 'findControlTextByKey'],
	components: { saveBtn },
	data () {
		return {
			imgIconDel: imgIcon
		}
	},
	created () {
		// Ensure that the number of perimeters matches the stories
		if (this.project.numStories > this.project.walls.perimeters.length) {
			const numPerimMiss = this.project.numStories - this.project.walls.perimeters.length

			for (let x = 0; x < numPerimMiss; x++) {
				this.project.walls.perimeters.push({
					enabled: true,
					values: [
						{
							orient: 'Front',
							length: 0
						},
						{
							orient: 'Left',
							length: 0
						},
						{
							orient: 'Back',
							length: 0
						},
						{
							orient: 'Right',
							length: 0
						},
						{
							orient: 'Attic',
							length: 0
						},
						{
							orient: 'Retaining',
							length: 0
						}
					]
				})
			}
		} else if (this.project.numStories < this.project.walls.perimeters.length) {
			const perimToDel = this.project.walls.perimeters.length - this.project.numStories
			this.project.walls.perimeters.splice(-Math.abs(perimToDel), perimToDel)
		}
	},
	methods: {
		deleteOtherWalls (index) {
			this.project.walls.other.splice(index, 1)
		},
		addOtherWall () {
			this.project.walls.other.push(
				{
					insul: 'TYP.WALL',
					orient: 'Front,Yes,HOUSE',
					area: '0.0'
				}
			)
		},
		getXwallInsul (value) {
			const result = []
			this.control.xWall_insul.map(selectValue => {
				if (selectValue.current || selectValue.value === value) {
					result.push(selectValue)
				}
			})
			// console.log('control.xWall_insul ', result)
			return result
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/walls-tab.vue